import 'zone.js'; // Included with Angular CLI.

(window as any).global = window;
global.Buffer = global.Buffer || require('buffer').Buffer;
window.Buffer = window.Buffer || require('buffer').Buffer;
global.process = require('process');
